import { render } from "./AcceptanceTerms.vue?vue&type=template&id=806f67c2&scoped=true"
import script from "./AcceptanceTerms.vue?vue&type=script&lang=js"
export * from "./AcceptanceTerms.vue?vue&type=script&lang=js"

import "./AcceptanceTerms.vue?vue&type=style&index=0&id=806f67c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806f67c2"]])

export default __exports__